import React from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import MenuFoldOutlined from "@ant-design/icons/MenuFoldOutlined";
import Logo from "@/components/logo/inbriefFullWhiteR.svg";

interface ChatHeaderProps {
    onClose: () => void;
}

export const ChatHeader: React.FC<ChatHeaderProps> = ({onClose}) => {
    return (
        <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} width={'100%'}>
            <IconButton
                aria-label="open drawer"
                onClick={onClose}
                edge="start"
                color="secondary"
                variant="light"
                sx={(theme) => ({
                    color: 'text.primary',
                    bgcolor: 'transparent',
                    ...theme.applyStyles('dark', { bgcolor:'transparent' })
                })}
            >
                {<MenuFoldOutlined />}
            </IconButton>
            <Typography>InBrief AI Assistant</Typography>
            {/*<Box
                component="img"
                src={Logo}
                alt="Logo"
                sx={{
                    width: 'auto',
                    height: '35px',
                    objectFit: 'contain',
                    display: 'block'
                }}
            />*/}
        </Box>
    );
};